module.exports = __webpack_public_path__ + "img/tender-vekop-01.b6b75e72.webp";